import Mutations from '../../odata/mutations';

export default { ...new Mutations('checklist'), ...new Mutations('checklists') };
